import { render, staticRenderFns } from "./Provider2.vue?vue&type=template&id=f36df7ac&"
import script from "./Provider2.vue?vue&type=script&lang=ts&"
export * from "./Provider2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports